import { pushToDataLayer } from '../utils/pushToDataLayer';
import { GACustomEvent } from '../utils/types';

export function filters(filter: string) {
    pushToDataLayer({
        event: GACustomEvent.Filters,
        applied_filters: filter,
    });
}
